const rIC =
    typeof requestIdleCallback === "function"
        ? requestIdleCallback
        : (cb, timeout) => {
              return setTimeout(() => {
                  requestAnimationFrame(() => {
                      cb()
                  })
              }, timeout || 200)
          }
const cIC = typeof cancelIdleCallback === "function" ? cancelIdleCallback : clearTimeout
export { rIC as requestIdleCallback, cIC as cancelIdleCallback }
